module.exports = __webpack_public_path__ + "static/Tadeas-Ksir-44047c8ae652e9c7b6468d25b2119fa5.webp";